import type DOMPurifyType from 'dompurify';

let domPurify: typeof DOMPurifyType | null = null;

async function getDOMPurify() {
  if (typeof window === 'undefined') {
    return null;
  }

  if (!domPurify) {
    domPurify = (await import('dompurify')).default;
  }
  return domPurify;
}

export async function sanitizeHtml(html: string) {
  if (!html) {
    return '';
  }

  const purify = await getDOMPurify();
  return purify ? purify.sanitize(html) : '';
}
